import React from 'react';
import PropTypes from 'prop-types';
import useAuth from '../hooks/useAuth';
import { Navigate, Outlet } from 'react-router-dom';

const ViewPaymentsGuard = () => {
  const { loggedInUser } = useAuth();

   const viewPaymentPermission =
      loggedInUser?.groups
        ?.map(g => g.defaultSubAccountRole.viewPayments)
        ?.filter(payPermission => !!payPermission)?.length > 0;
   const adminRead = loggedInUser?.adminRole.adminRead;

  return !!viewPaymentPermission || !!adminRead ? <Outlet /> : <Navigate to="/app/account-overview" />;
};

ViewPaymentsGuard.propTypes = {
  children: PropTypes.node
};

export default ViewPaymentsGuard;
